var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c(
          "b-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "10", "offset-md": "1" } },
                  [
                    _c("back-button"),
                    _vm._v(" "),
                    _c(
                      "h4",
                      { staticClass: "content-block labelAccordionForm" },
                      [
                        _c("f7-icon", {
                          staticClass: "formIcon",
                          attrs: { fa: "address-book" },
                        }),
                        _vm._v(" "),
                        _vm.user.type === "1"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("administration.company_edition"))
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type === "2"
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("administration.user_edition"))
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-start" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t("administration.user_id"),
                                inputValue: _vm.user.id,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                isMandatory: "",
                                inputLabel: _vm.$t("administration.user_login"),
                                placeholderValue: _vm.$t(
                                  "administration.user_login"
                                ),
                              },
                              model: {
                                value: _vm.userLogin,
                                callback: function ($$v) {
                                  _vm.userLogin = $$v
                                },
                                expression: "userLogin",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-read-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_active"
                                ),
                                inputValue: _vm.translateActive(
                                  _vm.user.active
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_date_activation"
                                ),
                              },
                              model: {
                                value: _vm.userDateActivation,
                                callback: function ($$v) {
                                  _vm.userDateActivation = $$v
                                },
                                expression: "userDateActivation",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.user.type == 1
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "administration.company_name"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userName,
                                    callback: function ($$v) {
                                      _vm.userName = $$v
                                    },
                                    expression: "userName",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type == 2
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "administration.user_firstname_name"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userName,
                                    callback: function ($$v) {
                                      _vm.userName = $$v
                                    },
                                    expression: "userName",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type == 1
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "administration.company_number"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userIdentifier,
                                    callback: function ($$v) {
                                      _vm.userIdentifier = $$v
                                    },
                                    expression: "userIdentifier",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type == 2
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "administration.user_identifier"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userIdentifier,
                                    callback: function ($$v) {
                                      _vm.userIdentifier = $$v
                                    },
                                    expression: "userIdentifier",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_email_reference"
                                ),
                              },
                              model: {
                                value: _vm.userEmailReference,
                                callback: function ($$v) {
                                  _vm.userEmailReference = $$v
                                },
                                expression: "userEmailReference",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_address"
                                ),
                              },
                              model: {
                                value: _vm.userAddress,
                                callback: function ($$v) {
                                  _vm.userAddress = $$v
                                },
                                expression: "userAddress",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_city"
                                ),
                              },
                              model: {
                                value: _vm.userCity,
                                callback: function ($$v) {
                                  _vm.userCity = $$v
                                },
                                expression: "userCity",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_zip_code"
                                ),
                              },
                              model: {
                                value: _vm.userZipCode,
                                callback: function ($$v) {
                                  _vm.userZipCode = $$v
                                },
                                expression: "userZipCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c(
                              "form-write-group-label-input",
                              {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t("administration.country"),
                                  inputType: "listeSelect",
                                },
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userCountry,
                                        expression: "userCountry",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { readonly: "" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.userCountry = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "administration.country_select"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function (country) {
                                      return _c(
                                        "option",
                                        { domProps: { value: country } },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(country) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.user.type == 1
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "administration.account_legal_form"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userLegalForm,
                                    callback: function ($$v) {
                                      _vm.userLegalForm = $$v
                                    },
                                    expression: "userLegalForm",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type == 1
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "administration.account_amount_of_capital"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userAmountOfCapital,
                                    callback: function ($$v) {
                                      _vm.userAmountOfCapital = $$v
                                    },
                                    expression: "userAmountOfCapital",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.user.type == 1
                          ? _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { sm: "6" } },
                              [
                                _c("form-write-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t(
                                      "administration.account_identifier_tva"
                                    ),
                                  },
                                  model: {
                                    value: _vm.userIdentifierTVA,
                                    callback: function ($$v) {
                                      _vm.userIdentifierTVA = $$v
                                    },
                                    expression: "userIdentifierTVA",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_phone_number"
                                ),
                              },
                              model: {
                                value: _vm.userPhoneNumber,
                                callback: function ($$v) {
                                  _vm.userPhoneNumber = $$v
                                },
                                expression: "userPhoneNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_api_endpoint"
                                ),
                              },
                              model: {
                                value: _vm.userAPIEndpoint,
                                callback: function ($$v) {
                                  _vm.userAPIEndpoint = $$v
                                },
                                expression: "userAPIEndpoint",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.account_type"
                                ),
                              },
                              model: {
                                value: _vm.userAccountType,
                                callback: function ($$v) {
                                  _vm.userAccountType = $$v
                                },
                                expression: "userAccountType",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "form-group", attrs: { sm: "6" } },
                          [
                            _c("form-write-group-label-input", {
                              attrs: {
                                inputLabel: _vm.$t(
                                  "administration.user_account_type"
                                ),
                              },
                              model: {
                                value: _vm.userType,
                                callback: function ($$v) {
                                  _vm.userType = $$v
                                },
                                expression: "userType",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "2", "offset-md": "9" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        on: { click: _vm.editUser },
                      },
                      [
                        _c("f7-icon", { attrs: { fa: "save" } }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }